import React from "react";
import { MagicIcon } from "./Icons";
import { Button } from "./ui/button";
import { useAuth } from "../contexts/AuthContext";

const Header: React.FC = () => {
  const { currentUser, userLoading, signInWithGoogle } = useAuth();

  return (
    <div className="py-4 px-8 w-full relative bg-background sidebar-backdrop border-2 border-border neo-shadow">
      <div className="mx-auto w-full max-w-screen-xl flex items-center">
        <img
          src="/instant3d-logo-black.svg"
          alt="Instant 3D AI"
          className="h-16 flex-shrink-0 mr-8"
        />

        <div className="flex-1 flex items-center justify-center gap-2">
          <MagicIcon />
          <div className="text-foreground text-lg font-medium whitespace-nowrap">
            Turn any image into a 3D model in about a minute
          </div>
        </div>

        {currentUser ? (
          <div />
        ) : (
          <Button
            size="sm"
            className="text-lg !font-medium ml-8"
            type="button"
            data-testid="sign-in-button"
            onClick={() => signInWithGoogle()}
            disabled={userLoading}
          >
            Sign In
          </Button>
        )}
      </div>
    </div>
  );
};

export default Header;
